// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3WvcV","header":"MergedInvoice_header__1FU3x"};